"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FindRecipientResult_1 = require("./FindRecipientResult");
var addHighlightedFindRecipient_1 = require("../actions/addHighlightedFindRecipient");
var parsePastedTextForRecipients_1 = require("../actions/parsePastedTextForRecipients");
var removeReadWriteRecipient_1 = require("../actions/removeReadWriteRecipient");
var resolveAllUnresolvedRecipients_1 = require("../actions/resolveAllUnresolvedRecipients");
var resolveQueryStringToRecipient_1 = require("../actions/resolveQueryStringToRecipient");
var setRecipientSelectedState_1 = require("../actions/setRecipientSelectedState");
var shiftFindResultHighlightIndex_1 = require("../actions/shiftFindResultHighlightIndex");
var showHideContactPicker_1 = require("../actions/showHideContactPicker");
var showHideFindResult_1 = require("../actions/showHideFindResult");
var updateFindControlQueryString_1 = require("../actions/updateFindControlQueryString");
var isValidEmailAddress_1 = require("../utils/isValidEmailAddress");
var searchDirectory_1 = require("../utils/searchDirectory");
var useTypedAddress_1 = require("../utils/useTypedAddress");
var mobx_react_1 = require("mobx-react");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var FindRecipientInfo_1 = require("owa-recipient-common/lib/components/FindRecipientInfo");
var React = require("react");
var KeyboardCharCodes_1 = require("owa-mail-hotkeys/lib/utils/KeyboardCharCodes");
var styles = require('./ReadWriteFindControl.scss');
var ReadWriteFindControl = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteFindControl, _super);
    function ReadWriteFindControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (evt) {
            var inputText = evt.target.value;
            updateFindControlQueryString_1.default(_this.props.recipientWell, inputText);
        };
        _this.onPaste = function (evt) {
            evt.preventDefault();
            var inputText = evt.clipboardData.getData('Text');
            parsePastedTextForRecipients_1.default(_this.props.recipientWell, inputText);
        };
        _this.onFocus = function (evt) {
            if (_this.props.shouldBlockForcedFocus && _this.isForcedFocus) {
                _this.isForcedFocus = false;
            }
            else if (evt.currentTarget == document.activeElement) {
                showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
            }
            showHideContactPicker_1.default(_this.props.recipientWell, false /* shouldShowContactPicker */);
        };
        _this.onClick = function (evt) {
            if (!_this.props.recipientWell.shouldShowFindResult) {
                showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
            }
        };
        _this.getQueryInputElement = function () {
            return _this.queryInputElement;
        };
        _this.onKeyDown = function (target) {
            switch (target.keyCode) {
                case KeyboardCharCodes_1.DOWN_ARROW_CHARCODE:
                    target.preventDefault();
                    shiftFindResultHighlightIndex_1.default(_this.props.recipientWell, true /* isIncrement */, _this.infoElementType);
                    return;
                case KeyboardCharCodes_1.UP_ARROW_CHARCODE:
                    if (_this.props.recipientWell.findResultHightlightIndex > -1) {
                        target.preventDefault();
                        shiftFindResultHighlightIndex_1.default(_this.props.recipientWell, false /* isIncrement */, _this.infoElementType);
                    }
                    return;
                case KeyboardCharCodes_1.LEFT_ARROW_CHARCODE:
                case KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE:
                    if (((target.keyCode == KeyboardCharCodes_1.LEFT_ARROW_CHARCODE && !Utilities_1.getRTL()) ||
                        (target.keyCode == KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE && Utilities_1.getRTL())) &&
                        _this.inputControl.selectionStart == 0 &&
                        _this.inputControl.selectionEnd == 0 &&
                        _this.props.recipientWell.recipients.length > 0) {
                        target.preventDefault();
                        setRecipientSelectedState_1.default(_this.props.recipientWell.recipients[_this.props.recipientWell.recipients.length - 1], true);
                    }
                    return;
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                case KeyboardCharCodes_1.TAB_CHARCODE:
                    if (!target.shiftKey) {
                        if (_this.props.recipientWell.findResultHightlightIndex > -1) {
                            target.preventDefault();
                            var resultsLength = _this.props.recipientWell.findResultSet.length;
                            if (_this.props.recipientWell.findResultHightlightIndex == resultsLength) {
                                if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.TopNResults &&
                                    resultsLength == 0) {
                                    target.preventDefault();
                                    resolveQueryStringToRecipient_1.default(_this.props.recipientWell, true /* shouldDirectlyResolve */);
                                }
                                if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory) {
                                    searchDirectory_1.default(_this.props.recipientWell);
                                }
                                else if (_this.infoElementType === FindRecipientInfo_1.FindRecipientInfoType.UseAddress) {
                                    useTypedAddress_1.default(_this.props.recipientWell);
                                }
                            }
                            else {
                                addHighlightedFindRecipient_1.default(_this.props.recipientWell);
                            }
                        }
                        else if (_this.props.recipientWell.queryString.length > 0) {
                            // When there are no results, just add the text as a recipient.
                            target.preventDefault();
                            resolveQueryStringToRecipient_1.default(_this.props.recipientWell, true /* shouldDirectlyResolve */);
                        }
                        else {
                            showHideFindResult_1.default(_this.props.recipientWell, false /* shouldShowFindResult */);
                        }
                    }
                    else {
                        showHideFindResult_1.default(_this.props.recipientWell, false /**shouldShowFindResult */);
                    }
                    return;
                case KeyboardCharCodes_1.K_CHARCODE:
                    if (target.ctrlKey) {
                        target.preventDefault();
                        resolveAllUnresolvedRecipients_1.default(_this.props.recipientWell);
                    }
                    return;
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    if (_this.inputControl.selectionStart == 0 && _this.inputControl.selectionEnd == 0) {
                        removeReadWriteRecipient_1.default(_this.props.recipientWell, _this.props.recipientWell.recipients.length - 1);
                        showHideFindResult_1.default(_this.props.recipientWell, true /**shouldShowFindResult */);
                    }
                    return;
            }
        };
        _this.bindQueryInputRef = function (ref) {
            if (ref) {
                _this.queryInputElement = ref;
            }
        };
        _this.getFindRecipientInfoType = function () {
            var recipientWell = _this.props.recipientWell;
            var hasQueryString = !!recipientWell.queryString;
            if (recipientWell.isSearching) {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.Searching;
            }
            else if (!hasQueryString && recipientWell.findResultSet.length == 0) {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.TypeToSearch;
            }
            else if (hasQueryString) {
                if (recipientWell.findResultSet.length == 0 &&
                    recipientWell.queryString.indexOf('@') >= 0 &&
                    isValidEmailAddress_1.default(recipientWell.queryString)) {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.UseAddress;
                }
                else if (!recipientWell.hasSearchedDirectory) {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory;
                }
                else {
                    _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.TopNResults;
                }
            }
            else {
                _this.infoElementType = FindRecipientInfo_1.FindRecipientInfoType.Default;
            }
            return _this.infoElementType;
        };
        return _this;
    }
    ReadWriteFindControl.prototype.focus = function () {
        this.isForcedFocus = true;
        this.inputControl.focus();
        this.inputControl.selectionStart = this.props.recipientWell.queryString.length;
    };
    ReadWriteFindControl.prototype.render = function () {
        var _this = this;
        var size = this.props.size;
        var inputClassName = size == 0 /* Small */
            ? styles.findControlInputSmall
            : styles.findControlInputRegular;
        return (React.createElement("span", { ref: this.bindQueryInputRef, className: this.props.className },
            React.createElement("input", { className: inputClassName, ref: function (ref) { return (_this.inputControl = ref); }, type: "text", value: this.props.recipientWell.queryString, onClick: this.onClick, onFocus: this.onFocus, onChange: this.onChange, onPaste: this.onPaste, onKeyDown: this.onKeyDown }),
            React.createElement(FindRecipientResult_1.default, { recipientWell: this.props.recipientWell, queryInputGetter: this.getQueryInputElement, findRecipientInfoType: this.getFindRecipientInfoType() })));
    };
    ReadWriteFindControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteFindControl);
    return ReadWriteFindControl;
}(React.Component));
exports.default = ReadWriteFindControl;
//# sourceMappingURL=ReadWriteFindControl.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/components/ReadWriteFindControl.js
// module id = 3388
// module chunks = 2 3